import React, { memo, useEffect } from 'react';
import styles from './ToggleButton.module.scss';

type Props = {
    onToggle?: () => void
    value?: boolean
    isOwner?: boolean
    className?: string
}


const ToggleButton: React.FC<Props> = memo((props: Props) => {

  const handleClick = () => {
    if (props.onToggle) props.onToggle(); // Passes the current state to the parent component
  };

  useEffect(() => {
  }, [props])

  return (
    <button
      className={`${styles.toggleButton} ${props?.className} ${props.value ? styles.active : ''} ${props.isOwner ? styles.disabled : ''}`}
      onClick={handleClick}
      disabled={props.isOwner}
    >
      <div className={`${styles.toggleBall} ${props.isOwner ? styles.disabled : ''}`}></div>
    </button>
  );
})

export default ToggleButton
